import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CandidatePageAction } from "../../../Redux/action/CandidatePageAction";
import { IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import {
  FaCheckCircle,
  FaEllipsisH,
  FaEye,
  FaTimesCircle,
} from "react-icons/fa";
import Pagination from "../../Common/Pagination/Pagination";
import { Button, Modal, Spinner } from "react-bootstrap";
import { MdAddTask, MdDelete } from "react-icons/md";
import {
  ActivateCandidate,
  DeactivateCandidate,
} from "../../../Services/candidateServies";
import { FiFilter } from "react-icons/fi";
import {
  fetchDesignationDetails,
  fetchSkillDetails,
} from "../../../Redux/action/MasterSkillAction";
import Select from "react-select";
import noImage from "../../../images/dummy_dp.png";

const CandidatePage = () => {
  const [data, setData] = useState({
    designation: "",
    minExperience: "",
    maxExperience: "",
    search: "",
    skills: [],
    locations: [],
    pageNumber: 0,
    pageSize: 8,
    status: "",
    // "flag": false
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activateModal, setActivateModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [selectedDesignation, setSelectedDesignation] = useState([]);
  const [designationSendapi, setDesignationSendAPI] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [skillVal, setSkillVal] = useState([]);
  const [activeTab, setActiveTab] = useState("ALL");
  const [filterActive, setFilterActive] = useState("ALL");
  const [id, setid] = useState();
  const [isloading, setIsLoading] = useState(false);
  const loader = useSelector((state) => state?.CandidatePageDashboard?.loading);
  const candidateData = useSelector(
    (state) => state?.CandidatePageDashboard?.result?.content
  );
  const totalPages = useSelector(
    (state) => state?.CandidatePageDashboard?.result?.totalPages
  );
  const AllDesignationList = useSelector(
    (state) => state?.MasterTableDetails?.designation?.content
  );
  const AllSkillList = useSelector(
    (state) => state?.MasterTableDetails?.skill?.content
  );
  useEffect(() => {
    data.designation = designationSendapi;
    data.status = filterActive;
    data.skills = skillVal;
    const fetchData = async () => {
      dispatch(CandidatePageAction(data));
    };
    fetchData();
  }, [
    data,
    dispatch,
    activateModal,
    deactivateModal,
    selectedDesignation,
    filterActive,
    activeTab,
    selectedSkills,
  ]);

  const handleDesignationChange = (selectedOptions) => {
    setSelectedDesignation(selectedOptions);
    const selectedValues = selectedOptions.map((option) => option.value);
    setDesignationSendAPI(selectedValues);
  };
  const handleSkillsChange = (selectedOptions) => {
    setSelectedSkills(selectedOptions);
    const selectedValues = selectedOptions.map((option) => option.value);
    setSkillVal(selectedValues);
  };

  const [showOptionsForId, setShowOptionsForId] = useState(null); // State to track which row's options are shown
  const optionsRef = useRef(null);

  const toggleOptions = (id) => {
    setShowOptionsForId(showOptionsForId === id ? null : id);
  };

  const handlePageChange = (page) => {
    // Update the pageNumber in the data state
    setData((prev) => ({
      ...prev,
      pageNumber: page,
    }));
  };

  useEffect(() => {
    dispatch(fetchDesignationDetails());
    dispatch(fetchSkillDetails());
    // Function to handle clicks outside the options menu
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowOptionsForId(null); // Close options menu if clicked outside
      }
    };
    // Add event listener to handle clicks outside the menu
    document.addEventListener("mousedown", handleClickOutside);
    // Clean up event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function handleActivate() {
    setIsLoading(true);
    ActivateCandidate(id)
      .then((res) => {
        setIsLoading(false);
        setActivateModal(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  function handleDeactivate() {
    setIsLoading(true);
    DeactivateCandidate(id)
      .then((res) => {
        setIsLoading(false);
        setDeactivateModal(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }
  const designationOptions = AllDesignationList?.map((item) => ({
    value: item?.designation,
    label: item?.designation,
  }));
  const options = AllSkillList?.map((item) => ({
    value: item?.skillName,
    label: item?.skillName,
  }));

  return (
    <div
      style={{
        backgroundColor: "#f6f9ff",
        paddingTop: "30px",
        height: "100vh",
      }}
    >
      <div
        className="common_wrapper "
        style={{ width: "99%", backgroundColor: "white" }}
      >
        <div
          className="card-header common_table_header"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div>Candidate Management</div>
          <div className="d-flex flex-column flex-xl-row flex-wrap gap-2">
            <div style={{ width: "200px" }}>
              <Select
                options={options}
                isMulti
                onChange={handleSkillsChange}
                placeholder="Select Skills"
                value={selectedSkills}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? "#286a94" : "#ccc",
                    boxShadow: state.isFocused ? "0 0 0 1px #286a94" : "none",
                    "&:hover": { borderColor: "#286a94" },
                    minHeight: "25px",
                    fontSize: "11px", // affects input text
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    padding: "6px 8px",
                    backgroundColor: state.isSelected
                      ? "#286a94"
                      : state.isFocused
                      ? "#e6f2fa"
                      : "white",
                    color: state.isSelected ? "white" : "#333",
                  }),
                  multiValue: (base) => ({
                    ...base,
                    backgroundColor: "#e6f2fa",
                    borderRadius: "8px",
                    padding: "0px 0px",
                  }),
                  multiValueLabel: (base) => ({
                    ...base,
                    fontSize: "11px",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "11px",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#777",
                    fontSize: "14px",
                  }),
                }}
              />
            </div>
            <div style={{ width: "200px" }}>
              <Select
                options={designationOptions}
                isMulti
                onChange={handleDesignationChange}
                placeholder="Select Designation"
                value={selectedDesignation}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? "#286a94" : "#ccc",
                    boxShadow: state.isFocused ? "0 0 0 1px #286a94" : "none",
                    "&:hover": { borderColor: "#286a 94" },
                    minHeight: "25px",
                    fontSize: "11px", // affects input text
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    padding: "6px 8px",
                    backgroundColor: state.isSelected
                      ? "#286a94"
                      : state.isFocused
                      ? "#e6f2fa"
                      : "white",
                    color: state.isSelected ? "white" : "#333",
                  }),
                  multiValue: (base) => ({
                    ...base,
                    backgroundColor: "#e6f2fa",
                    borderRadius: "8px",
                    padding: "0px 0px",
                  }),
                  multiValueLabel: (base) => ({
                    ...base,
                    fontSize: "11px", // selected tag label font size
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "11px", // for single select case
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#777",
                    fontSize: "14px",
                  }),
                }}
              />
            </div>
            <div className="d-flex flex-wrap gap-2">
              {/* <div style={{ position: 'relative', display: 'inline-block' }}>
                                <FiFilter style={{ position: 'absolute', top: '22px', left: '8px', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
                                <select
                                    style={{
                                        padding: '7px 12px 7px 32px', // Padding adjusted to make space for the icon
                                        borderRadius: '4px',
                                        fontSize: '16px',
                                        border: '1px solid #e2e8f0',
                                        appearance: 'none' // This hides the default dropdown arrow
                                    }}
                                    id='select'
                                    value={activeTab}
                                    onChange={(e) => setActiveTab(e.target.value)}
                                >
                                    <option value='ALL'>All</option>
                                    <option value='VERIFIED'>VERIFIED</option>
                                    <option value='NOT_VERIFIED'>NOT VERIFIED</option>
                                </select>
                            </div> */}
              <div style={{ position: "relative", display: "inline-block" }}>
                <FiFilter
                  style={{
                    position: "absolute",
                    top: "22px",
                    left: "8px",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                />
                <select
                  style={{
                    padding: "7px 12px 7px 32px", // Padding adjusted to make space for the icon
                    borderRadius: "4px",
                    fontSize: "16px",
                    border: "1px solid #e2e8f0",
                    appearance: "none", // This hides the default dropdown arrow
                  }}
                  id="select"
                  value={filterActive}
                  onChange={(e) => setFilterActive(e.target.value)}
                >
                  <option value="ALL">All</option>
                  <option value="ACTIVE">Activated</option>
                  <option value="INACTIVE">Deactivated</option>
                  <option value="INDIVIDUAL">Individual</option>
                  <option value="TEAM_MEMBER">Team Member</option>
                </select>
              </div>
              <div
                style={{
                  width: "13rem",
                  height: "40px",
                  backgroundColor: "white",
                  borderRadius: "0.275rem",
                  display: "flex",
                  border: "1px solid #eee6e4",
                }}
              >
                <div
                  style={{
                    width: "2rem",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IoSearch style={{ color: "#286A94", fontSize: "1.25rem" }} />
                </div>
                <input
                  className="small-placeholder"
                  style={{
                    width: "100%",
                    height: "66.67%",
                    margin: "auto 0",
                    paddingLeft: "0.5rem",
                    outline: "none",
                    border: "none",
                  }}
                  placeholder="Search by name"
                  type="text"
                  value={data?.search}
                  onChange={(e) =>
                    setData((prev) => ({
                      ...prev,
                      search: e.target.value,
                      pageNumber: 0,
                    }))
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive" style={{ paddingBottom: "15px" }}>
            <table
              className="table table-hover"
              style={{
                width: "100%",
                minWidth: "900px",
                fontFamily: "Poppins, sans-serif",
                fontSize: "14px",
              }}
            >
              <thead style={{ backgroundColor: "#f5f7fa", whiteSpace:"nowrap",}}>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile No.</th>
                  <th>Designation</th>
                  <th>Experience</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loader ? (
                  <tr>
                    <td colSpan="8" className="text-center p-3">
                      <Spinner style={{ color: "#286a94" }} />
                    </td>
                  </tr>
                ) : candidateData && candidateData.length > 0 ? (
                  candidateData.map((item) => (
                    <tr key={item?.candidateId}>
                      <td
                        style={{
                          color: item?.isTeamMember ? "#1976d2" : "#dede5e",
                          whiteSpace:"nowrap",
                        }}
                      >
                        {item?.candidate_type}
                      </td>

                      <td
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                        title={`${item?.firstName} ${item?.lastName}`}
                      >
                        <img
                          src={item.profileImageUrl || noImage}
                          alt="profile"
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            flexShrink: 0,
                            objectFit: "cover",
                          }}
                        />
                        <span
                          style={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {`${item?.firstName} ${item?.lastName}`}
                        </span>
                      </td>

                      <td
                        style={{
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={item?.email}
                      >
                        {item?.email}
                      </td>

                      <td>{"+" + item?.dialCode + " " + item?.mobile}</td>
                      <td>{item?.currentDesignation || "N/A"}</td>
                      <td>
                        {(() => {
                          const years = parseInt(item?.keyExperience) || 0;
                          const months =
                            parseInt(item?.keyExperienceInMonth) || 0;

                          if (years === 0 && months === 0) return "Fresher";
                          if (years === 0)
                            return `${months} Month${months > 1 ? "s" : ""}`;
                          if (months === 0)
                            return `${years} Year${years > 1 ? "s" : ""}`;
                          return `${years} Year${
                            years > 1 ? "s" : ""
                          } ${months} Month${months > 1 ? "s" : ""}`;
                        })()}
                      </td>

                      <td>
                        {item?.activeStatus ? (
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 6,
                              padding: "4px 12px",
                              borderRadius: "20px",
                              backgroundColor: "#e0f7e9",
                              color: "#2e7d32",
                              fontWeight: 500,
                              fontSize: "12px",
                              whiteSpace:"nowrap",
                              boxShadow: "0 2px 5px rgba(46,125,50,0.2)",
                            }}
                          >
                            <FaCheckCircle /> Activated
                          </span>
                        ) : (
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 6,
                              padding: "4px 12px",
                              borderRadius: "20px",
                              backgroundColor: "#ffe5e5",
                              color: "#d32f2f",
                              fontWeight: 500,
                              fontSize: "12px",
                              whiteSpace:"nowrap",
                              boxShadow: "0 2px 5px rgba(211,47,47,0.2)",
                            }}
                          >
                            <FaTimesCircle /> Deactivated
                          </span>
                        )}
                      </td>

                      <td>
                        <div style={{ position: "relative" }}>
                          <FaEllipsisH
                            onClick={() => toggleOptions(item?.candidateId)}
                            style={{ cursor: "pointer" }}
                          />
                          {showOptionsForId === item?.candidateId && (
                            <div
                              ref={optionsRef}
                              style={{
                                position: "absolute",
                                top: "100%",
                                right: 0,
                                width: 150,
                                borderRadius: 8,
                                backgroundColor: "#fff",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                zIndex: 100,
                                overflow: "hidden",
                                transition: "all 0.2s ease",
                              }}
                            >
                              {[
                                {
                                  label: "View",
                                  icon: <FaEye />,
                                  action: () =>
                                    navigate(
                                      `/admin/candidate/viewCandidate?candidateId=${item?.candidateId}`
                                    ),
                                },
                                item?.activeStatus
                                  ? {
                                      label: "Deactivate",
                                      icon: <MdDelete />,
                                      action: () => {
                                        setDeactivateModal(true);
                                        setid(item?.candidateId);
                                      },
                                    }
                                  : {
                                      label: "Activate",
                                      icon: <MdAddTask />,
                                      action: () => {
                                        setActivateModal(true);
                                        setid(item?.candidateId);
                                      },
                                    },
                              ].map((option, idx) => (
                                <div
                                  key={idx}
                                  onClick={option.action}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "10px 12px",
                                    cursor: "pointer",
                                    transition: "background 0.2s",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      "#f1f5f9")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      "#fff")
                                  }
                                >
                                  <span>{option.label}</span>
                                  {option.icon}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center p-3">
                      <h5 style={{ fontSize: "14px" }}>No Data Found</h5>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {candidateData?.length >= 1 && (
              <Pagination
                totalPages={totalPages}
                currentPage={data?.pageNumber || 0}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </div>
      </div>
      <Modal
        show={deactivateModal}
        onHide={() => {
          setDeactivateModal(false);
          setid("");
        }}
        backdrop="static"
        keyboard={false}
        style={{ top: "30%" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Deactivate</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to Deactivate this candidate?</Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            disabled={isloading}
            className="btn-lg btn-primary-custom"
            onClick={() => handleDeactivate()}
          >
            {isloading ? "Loading..." : "Yes"}
          </Button>
          <Button
            variant="secondary"
            className="btn-lg"
            onClick={() => {
              setDeactivateModal(false);
              setid("");
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={activateModal}
        onHide={() => {
          setActivateModal(false);
          setid("");
        }}
        backdrop="static"
        keyboard={false}
        style={{ top: "30%" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Activate</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to Activate this candidate?</Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            disabled={isloading}
            className="btn-lg btn-primary-custom"
            onClick={() => handleActivate()}
          >
            {isloading ? "Loading..." : "Yes"}
          </Button>
          <Button
            variant="secondary"
            className="btn-lg"
            onClick={() => {
              setActivateModal(false);
              setid("");
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CandidatePage;
